// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tab-list":"tab__tab-list___ja-Ht","tabList":"tab__tab-list___ja-Ht","tab":"tab__tab___2Rx4B","tab-button":"tab__tab-button___20xiu","tabButton":"tab__tab-button___20xiu","active":"tab__active___1VJIn"};
    if(module.hot) {
      // 1769133275516
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  